import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { PruefstatusArea } from '../../types';
import { ComplianceStatusBadge } from '../../atoms/ComplianceStatusBadge';
import './PruefstatusAreaCard.css';

export interface PruefstatusAreaCardProps {
  /** Area data */
  area: PruefstatusArea;
  /** Callback when card is clicked for drill-down */
  onClick?: (areaId: string) => void;
  /** Optional custom className */
  className?: string;
}

export const PruefstatusAreaCard: React.FC<PruefstatusAreaCardProps> = ({
  area,
  onClick,
  className = '',
}) => {
  const openTotal = area.open_action_required + area.open_warnings;

  return (
    <div
      className={`pruefstatus-area-card ${onClick ? 'pruefstatus-area-card--clickable' : ''} ${className}`.trim()}
      onClick={() => onClick?.(area.area_id)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick(area.area_id);
        }
      }}
    >
      <div className="pruefstatus-area-card__header">
        <h3 className="pruefstatus-area-card__title">{area.area_name}</h3>
        <ComplianceStatusBadge status={area.status} />
      </div>

      <div className="pruefstatus-area-card__stats">
        {openTotal > 0 && (
          <span className="pruefstatus-area-card__stat pruefstatus-area-card__stat--open">
            {openTotal} {openTotal === 1 ? 'offener Punkt' : 'offene Punkte'}
          </span>
        )}
        {typeof area.total_contracts === 'number' && (
          <span className="pruefstatus-area-card__stat">
            {area.fulfilled_contracts ?? 0} / {area.total_contracts} Kontrakte erfüllt
          </span>
        )}
      </div>

      {area.summary_text && <p className="pruefstatus-area-card__summary">{area.summary_text}</p>}

      {onClick && (
        <div className="pruefstatus-area-card__footer">
          <span className="pruefstatus-area-card__link">
            Details anzeigen <ChevronRight size={14} />
          </span>
        </div>
      )}
    </div>
  );
};

export default PruefstatusAreaCard;
